@switch (visibility().level) {
  @case (VisibilityLevel.Public) {
    <rt-badge
      [color]="'secondary'"
      [style.white-space]="'nowrap'"
      [text]="'app.visibility.access_by_everyone' | translate"
    />
  }

  @case (VisibilityLevel.Private) {
    <rt-badge
      [color]="'secondary'"
      [style.white-space]="'nowrap'"
      [text]="'app.visibility.access_by_me' | translate"
    />
  }

  @case (VisibilityLevel.Protected) {
    <rt-admins-avatars
      [avatarSize]="'small-x'"
      [tooltipsEnabled]="false"
      [admins]="usersToShow"
      [stacked]="true"
      [limit]="avatarsLimit"
      [moreButtonAsCounter]="true"
      [counterAvatarTemplate]="counterTpl"
    />

    <ng-template #counterTpl>
      <div
        class="avatar-counter"
        rtTooltip
        rtTooltipPosition="below"
        [rtTooltipTemplate]="moreTooltipTemplate"
      >
        {{ avatarMoreCounter }}
      </div>
    </ng-template>

    <ng-template #moreTooltipTemplate>
      <div class="admins-tooltip">
        <div class="admins-tooltip-header">
          {{ moreTitle() }}
        </div>
        <div class="admins-tooltip-list">
          @for (user of usersToShowInTooltip; track trackBy($index, user)) {
            <div class="admins-tooltip-list-item">
              <rt-avatar
                size="small"
                margin-right-small-x
                [type]="user.hasAvatar ? 'image' : 'initials'"
                [imageSrc]="user.photoThumbUrl"
                [initials]="user.initials"
              />
              <rt-truncate [style.overflow]="'hidden'"
                >{{ user.firstName }} {{ user.lastName }}</rt-truncate
              >
            </div>
          }

          @if (tooltipMoreCounter > 0) {
            <div class="admins-tooltip-list-item">
              <span class="admins-left-count" margin-right-small-x>
                {{ tooltipMoreCounter }}
              </span>
              <span>{{ 'app.common.other' | translate }}</span>
            </div>
          }
        </div>
      </div>
    </ng-template>
  }
}
